import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledTitle = styled.span`
  ${({
    theme: {
      typography: {
        headings: {
          xsmall: { bundledCSS: xsmallHeading },
        },
      },
      colors: { staticNeutral100 },
      spacing: { spacing8 },
    },
  }) => {
    return css`
      ${xsmallHeading};
      color: ${staticNeutral100};
      margin-right: ${spacing8};
    `
  }}
`

const Title: FunctionComponent<{ children?: ReactNode }> = ({ children }) => (
  <StyledTitle>{children}</StyledTitle>
)

export default Title
